import image1 from 'images/vegetables/vegetable-1.jpg';
import image2 from 'images/vegetables/vegetable-2.jpg';
import image3 from 'images/vegetables/vegetable-3.jpg';
import image4 from 'images/vegetables/vegetable-4.jpg';
import image5 from 'images/vegetables/vegetable-5.jpg';
import image6 from 'images/vegetables/vegetable-6.jpg';
import image7 from 'images/vegetables/vegetable-7.jpg';
import image8 from 'images/vegetables/vegetable-8.jpg';
import image9 from 'images/vegetables/vegetable-9.jpg';
import image10 from 'images/vegetables/vegetable-10.jpg';
import image11 from 'images/vegetables/vegetable-11.jpg';
import image12 from 'images/vegetables/vegetable-12.jpg';
import image13 from 'images/vegetables/vegetable-13.jpg';
import image14 from 'images/vegetables/vegetable-14.jpg';
import image15 from 'images/vegetables/vegetable-15.jpg';
import image16 from 'images/vegetables/vegetable-16.jpg';
import image17 from 'images/vegetables/vegetable-17.jpg';
import image18 from 'images/vegetables/vegetable-18.jpg';

import bottle from 'images/product-bottle.jpg';

export const products = [
    { name: 'Wuxal Р Мах', img: bottle },
    { name: 'Wuxal Universal Active', img: bottle },
    { name: 'Wuxal MacroMix', img: bottle },
    { name: 'Wuxal Boron pH', img: bottle },
    { name: 'Wuxal Oilseed PLUS', img: bottle },
    { name: 'Wuxal CalciBor', img: bottle },
    { name: 'Wuxal Combi PLUS', img: bottle },
    { name: 'Wuxal Microplant', img: bottle },
];

export const vegetables = [
    { name: 'Cereals', img: image2 },
    { name: 'Corn', img: image1 },
    { name: 'Sunflower', img: image8 },
    { name: 'Pulses (soybeans, peas)', img: image7 },
    { name: 'Winter rape', img: image6 },
    { name: 'Sugar beet', img: image5 },
    { name: 'Cabbage', img: image4 },
    { name: 'Potatoes', img: image3 },
];

export const vegetables2 = [
    { name: 'Corn', img: image1 },
    { name: 'Sunflower', img: image8 },
    { name: 'Winter rape', img: image6 },
    { name: 'Cabbage', img: image4 },
    { name: 'Potatoes', img: image3 },
    { name: 'Cereals', img: image2 },
    { name: 'Sugar beet', img: image5 },
    { name: 'Pulses (soybeans, peas)', img: image7 },
];

export const tabsData = [
    {
        title: 'Field trial in Ukraine',
        data: vegetables,
    },
    {
        title: 'Field trial in other countries',
        data: products,
    },
];

export const vegetablesFull = [
    { name: 'Corn', img: image1 },
    { name: 'Sunflower', img: image8 },
    { name: 'Winter rape', img: image6 },
    { name: 'Cabbage', img: image4 },
    { name: 'Potatoes', img: image3 },
    { name: 'Cereals', img: image2 },
    { name: 'Sugar beet', img: image5 },
    { name: 'Pulses (soybeans, peas)', img: image7 },
    { name: 'Onion', img: image9 },
    { name: 'Tomato, eggplant, pepper', img: image10 },
    { name: 'Root vegetables (carrots, beets)', img: image11 },
    { name: 'Stone berries, fruits', img: image12 },
    { name: 'Grains', img: image13 },
    { name: 'Hazelnut', img: image14 },
    { name: 'Grapes', img: image15 },
    { name: 'Strawberries', img: image16 },
    { name: 'Blueberries', img: image17 },
    { name: 'Currants, raspberries', img: image18 },
];
